export default __webpack_public_path__ + "static/media/fureverhomes.ec2916a9.png";